import { Layout } from "@entaconsulting/form";
import resolveLayoutElement from "../components/jsonSchema/resolveJsonElement";

const getLayoutElementAtPath = (path: string, layoutObject: Layout) => {
  if (path.startsWith("body")) {
    return resolveLayoutElement(
      layoutObject.elements,
      path.split("/").slice(1)
    );
  } else {
    // It is header
    return resolveLayoutElement(
      layoutObject.header?.elements!,
      path.split("/").slice(1)
    );
  }
};

export default getLayoutElementAtPath;
